import { useMemo } from 'react'

import { useConnect } from 'redux-bundler-hook'

import { defaultAllowedTypes } from '~/src/Annotations/constants'
import appConfig from '~/src/App/config'
import { ALLOWED_TIER_JOURNAL_TABS } from '~/src/Flags/Tier/constants'
import { getDateTime, noop } from '~/src/Lib/Utils'

const defaultParams = {
  showComplete: true,
}

export const EVERYTHING_TAB = 'everything'
export const TASKS_TAB = 'tasks'
export const ALERTS_TAB = 'alerts'
export const IPM_TAB = 'ipm'
export const HARVESTS_TAB = 'harvests'
export const NOTES_TAB = 'notes'

const initialTabsData = [
  {
    label: 'Everything',
    value: EVERYTHING_TAB,
    testId: 'tab_everything',
    annotationTypes: [...defaultAllowedTypes].sort(),
    get params() {
      this.$params ??= { types: this.annotationTypes }
      return this.$params
    },
  },
  {
    label: 'Tasks',
    value: TASKS_TAB,
    testId: 'tab_tasks',
    annotationTypes: ['task'],
    get params() {
      this.$params ??= {
        category: null,
        types: this.annotationTypes
      }
      return this.$params
    },
  },
  {
    label: 'Notes',
    value: NOTES_TAB,
    testId: 'tab_notes',
    annotationTypes: ['note'],
    get params() {
      this.$params ??= { types: this.annotationTypes }
      return this.$params
    },
  },
  {
    label: 'Alerts',
    value: ALERTS_TAB,
    testId: 'tab_alerts',
    annotationTypes: ['notification'],
    get params() {
      this.$params ??= { types: this.annotationTypes }
      return this.$params
    },
  },
  {
    label: 'IPM',
    value: IPM_TAB,
    testId: 'tab_pests',
    annotationTypes: ['pesticideApplication', 'task'],
    get params() {
      this.$params ??= {
        taskBehavior: 'PEST',
        showComplete: false,
        types: this.annotationTypes
      }
      return this.$params
    },
  },
  {
    label: 'Plant Events',
    value: HARVESTS_TAB,
    testId: 'tab_harvests',
    annotationTypes: ['harvestPhase'],
    get params() {
      this.$params ??= { types: this.annotationTypes }
      return this.$params
    },
  },
]

export const useTabsData = () => {
  const { config: { TIER } } = useConnect('selectConfig')
  const { [TIER]: allowedTabs = ALLOWED_TIER_JOURNAL_TABS.DEFAULT } = ALLOWED_TIER_JOURNAL_TABS
  return useMemo(() => initialTabsData
    .filter(tab => allowedTabs.has(tab.value))
    .map(({ params: ownParams, ...rest }) => ({ ...rest, params: { ...defaultParams, ...ownParams } })), [allowedTabs])
}

export const tabsData = (
  appConfig.APP === 'AROYA'
    ? initialTabsData
    : initialTabsData.slice(0, -2)
).map(({ params: ownParams, ...rest }) => ({ ...rest, params: { ...defaultParams, ...ownParams } }))

export const dateFilters = [
  {
    label: 'All',
    value: 'ALL',
    getDates: noop,
  },
  {
    label: 'Today',
    value: 'TODAY',
    getDates: () => {
      const start = getDateTime('now').startOf('day')

      return {
        start,
        end: start.plus({ days: 1 })
      }
    }
  },
  {
    label: 'Tomorrow',
    value: 'TOMORROW',
    getDates: () => {
      const start = getDateTime('now').startOf('day').plus({ days: 1 })

      return {
        start,
        end: start.plus({ days: 1 })
      }
    }
  },
  {
    label: 'This week',
    value: 'THIS_WEEK',
    getDates: () => {
      const start = getDateTime('now').startOf('week')

      return {
        start,
        end: start.endOf('week')
      }
    }
  },
]
